import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { Field } from 'react-final-form';

import {
    normalizers,
    validators,
    RenderField,
    RenderCheckbox,
    RenderDatePicker
} from 'forms';
import FieldValue from 'components/FieldValue';

import { CertificationsFieldName } from '../../constants';

// Normalizers
const { toNull } = normalizers;

// Validators
const { isRequired } = validators;

export default class CertificationsForm extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <Grid>
                <Grid.Column width={16}>
                    <Header as="h3">Spray Certification</Header>
                </Grid.Column>

                <Grid.Column width={16}>
                    <Field
                        name={CertificationsFieldName.CERTIFICATION_PENDING}
                        component={RenderCheckbox as any}
                        label="Spray certification pending"
                    />
                </Grid.Column>
                <FieldValue name="isCertificationPending">
                    {(isCertificationPending) =>
                        isCertificationPending ? null : (
                            <React.Fragment>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Field
                                        name={
                                            CertificationsFieldName.CERTIFICATE_NUMBER
                                        }
                                        component={RenderField as any}
                                        label="Certificate number"
                                        type="text"
                                        placeholder="Enter certificate number"
                                        parse={toNull}
                                        validate={isRequired}
                                    />
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Field
                                        name={
                                            CertificationsFieldName.CERTIFICATE_EXPIRY_DATE
                                        }
                                        component={RenderDatePicker as any}
                                        label="Expiry date"
                                        placeholder="Pick an expiry date"
                                        form
                                        parse={toNull}
                                        validate={isRequired}
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </Grid.Column>
                            </React.Fragment>
                        )
                    }
                </FieldValue>
            </Grid>
        );
    }
}
